<template>
  <section>
    <div class="columns soccer-chalkboard__header" ref="soccerChalkboard">
      <div class="column is-8 soccer-chalkboard__header__switch">
        <span v-if="isVisualizationTextVisible" class="control-label is-inline-flex is-pulled-left field-title">
          {{ $t('chalkboard.display') }}:
        </span>
        <div class="field">
          <span class="control-label right">2D</span>
          <BSwitch v-model="perspective" passive-type="is-primary"></BSwitch>
          <span class="control-label left">3D</span>
        </div>
      </div>
      <div class="column is-4 has-vertical-divider title">{{ $t('chalkboard.categories') }}</div>
    </div>
    <div class="columns">
      <div class="column is-8 has-gray-background">
        <div class="title-field">Haz clic en cualquier jugada para ver el video</div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          :viewBox="chalkboardViewBox"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          class="soccer-chalkboard"
          :class="{ perspective3d: perspective, perspective2d: !perspective }"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 452 684" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Flechas -->
            <defs>
              <marker
                id="arrow-negative"
                viewBox="0 0 10 10"
                refX="5"
                refY="5"
                markerWidth="6"
                markerHeight="6"
                markerUnits="strokeWidth"
                orient="auto"
              >
                <path d="M 0 0 L 10 5 L 0 10 z" stroke-width="2" fill="red" />
              </marker>
              <marker
                v-for="c in localCategories"
                :key="`arrow-color-${c.id}`"
                :id="`arrow-${c.id}`"
                viewBox="0 0 10 10"
                refX="5"
                refY="5"
                markerWidth="6"
                markerHeight="6"
                markerUnits="strokeWidth"
                orient="auto"
              >
                <path d="M 0 0 L 10 5 L 0 10 z" stroke-width="2" :fill="c.color" />
              </marker>
              <pattern id="fieldBackground" width="1" height="1" viewBox="0 0 100 100" preserveAspectRatio="none">
                <image
                  xlink:href="https://golstatsimages.blob.core.windows.net/todoelfut/fieldbg.png"
                  width="100"
                  height="100"
                  preserveAspectRatio="none"
                  id="image2"
                />
              </pattern>
            </defs>
            <!-- Cancha -->
            <g id="soccer-field">
              <rect opacity=".8" height="684" width="452" fill="url(#fieldBackground)" />
              <g
                id="g19"
                transform="matrix(1,0,0,0.96314115,0,12.524864)"
                stroke="#eeffee"
                fill="none"
                stroke-width="3"
              >
                <path d="m 11.22,22.62 v 638.8 h 429.6 V 22.62 Z" id="path4" />
                <path d="m 11.26,342 h 429.4" id="path6" />
                <circle cy="342" cx="226" r="54.799999" id="circle8" />
                <circle cy="342" cx="226" r="2" id="circle10" />
                <g id="a">
                  <path
                    d="m 9.9,30.07 c 4.85,0 8.82,-4 8.82,-8.9 m 162.5,100.8 a 54.91,54.91 0 0 0 89.6,0 m 76.3,-99.63 v
                    99.63 h -242.2 l 0.2,-99.63 m 98.6,0.2 V 6.94 l 44.6,0.003 v 15.6 m -77.9,-0.2 v 34.4 h 111.2 v
                    -34.4 m 160.5,7.7 c -4.9,0 -8.8,-4 -8.8,-8.9"
                    id="path12"
                  />
                  <circle cy="90" cx="226" r="2" id="circle14" />
                </g>
                <use xlink:href="#a" transform="scale(1,-1)" y="-684" x="0" width="100%" height="100%" />
              </g>
            </g>
            <!-- Jugadas de 3 puntos -->
            <g v-for="play in plays3" :key="play.id" :id="`play-${play.playId}`" @click="setOpenMedia(play, 2)">
              <line
                :x1="`${play.x1}%`"
                :y1="`${play.y1}%`"
                :x2="`${play.x2}%`"
                :y2="`${play.y2}%`"
                :stroke="play.arrowColor"
                stroke-width="2"
              />
              <line
                :x1="`${play.x2}%`"
                :y1="`${play.y2}%`"
                :x2="`${play.x3}%`"
                :y2="`${play.y3}%`"
                :stroke="play.arrowColor"
                stroke-width="2"
                :marker-end="play.arrowMarkerColor"
              />
              <g
                @mouseover="onMouseOver($event, play)"
                @mouseleave="onMouseLeave"
                @click="onClickOver($event, play)"
                class="is-pointer"
              >
                <rect
                  :x="`${play.x1}%`"
                  :y="`${play.y1}%`"
                  transform="translate(-11, -11)"
                  height="22"
                  width="22"
                  stroke-width="2"
                  fill="white"
                  :stroke="play.markerColor"
                  rx="4"
                  ry="4"
                />
                <text
                  text-anchor="middle"
                  dominant-baseline="middle"
                  :x="`${play.x1}%`"
                  :y="`${play.y1}%`"
                  dy="1"
                  font-size="12"
                  stroke="black"
                >
                  {{ play.jersey }}
                </text>
              </g>
            </g>
            <!-- Jugadas de 2 puntos -->
            <g v-for="play in plays2" :key="play.id" :id="`play-${play.playId}`" @click="setOpenMedia(play, 2)">
              <line
                :x1="`${play.x1}%`"
                :y1="`${play.y1}%`"
                :x2="`${play.x2}%`"
                :y2="`${play.y2}%`"
                stroke-width="2"
                :stroke="play.arrowColor"
                :marker-end="play.arrowMarkerColor"
              />
              <g
                @mouseover="onMouseOver($event, play)"
                @mouseleave="onMouseLeave"
                @click="onClickOver($event, play)"
                class="is-pointer"
              >
                <rect
                  :x="`${play.x1}%`"
                  :y="`${play.y1}%`"
                  transform="translate(-10, -10)"
                  height="20"
                  width="20"
                  stroke-width="2"
                  fill="white"
                  :stroke="play.markerColor"
                  rx="4"
                  ry="4"
                />
                <text
                  text-anchor="middle"
                  dominant-baseline="middle"
                  :x="`${play.x1}%`"
                  :y="`${play.y1}%`"
                  dy="1"
                  font-size="12"
                  stroke="black"
                >
                  {{ play.jersey }}
                </text>
              </g>
            </g>
            <!-- Jugadas de 1 punto -->
            <g
              v-for="play in plays1"
              :key="play.id"
              :id="`play-${play.playId}`"
              class="is-pointer"
              @mouseover="onMouseOver($event, play)"
              @mouseleave="onMouseLeave"
              @click="setOpenMedia(play, 2)"
            >
              <rect
                :x="`${play.x1}%`"
                :y="`${play.y1}%`"
                transform="translate(-10, -10)"
                height="20"
                width="20"
                stroke-width="2"
                fill="white"
                :stroke="play.color"
                rx="4"
                ry="4"
              />
              <text
                text-anchor="middle"
                dominant-baseline="middle"
                :x="`${play.x1}%`"
                :y="`${play.y1}%`"
                dy="1"
                font-size="12"
                stroke="black"
              >
                {{ play.jersey }}
              </text>
            </g>
          </svg>
          <svg>
            <defs>
              <marker
                id="arrow-gray"
                viewBox="0 0 10 10"
                refX="5"
                refY="5"
                markerWidth="6"
                markerHeight="6"
                markerUnits="strokeWidth"
                orient="auto"
              >
                <path d="M 0 0 L 10 5 L 0 10 z" stroke-width="2" fill="#c9c8c8" />
              </marker>
            </defs>
            <line x1="482" y1="600" x2="482" y2="200" stroke="#c9c8c8" stroke-width="3" marker-end="url(#arrow-gray)" />
          </svg>
        </svg>
        <div v-if="istotalXgfVisible">{{ $t('chalkboard.xG_accumulated') }}: {{ totalXgf | ceilMod }}</div>
        <div>{{ $t('chalkboard.total_events') }}: {{ totalPlays }}</div>
      </div>
      <div class="column is-4 has-text-left">
        <div
          class="field has-horizontal-divider"
          v-for="(category, index) in localCategories"
          :key="`category-${category.id}`"
        >
          <BCheckbox
            :native-value="category.id"
            v-model="selectedPlays"
            :name="category.name"
            @change.native="onClickCategory"
          ></BCheckbox>
          <div class="categoryline">
            <div class="categoryline__cate">{{ category.name }}</div>
            <img
              src="https://golstatsimages.blob.core.windows.net/todoelfut/playdes.png"
              @click="setOpenMedia(category.categories, 1, index)"
            />
          </div>
        </div>
        <div atributo="atributo" class="field">
          <BButton type="is-primary" expanded @click="onClickSelectAll">{{
            isFullCategoriesSelected ? $t('chalkboard.unselect_all') : $t('chalkboard.select_all')
          }}</BButton>
        </div>
      </div>
    </div>
    <Tooltip :data="data">
      <div class="tooltip-data has-text-left" ref="collabsibles" :class="[data.visible ? 'visible' : '']">
        <div>
          <span class="bold">{{ $t('chalkboard_tooltip.category') }}:</span>
          {{ dataPlay.isOwnGoal ? 'Autogol' : dataPlay.categoryName }}
        </div>
        <div v-if="!isPlayerView">
          <span class="bold">{{ $t('chalkboard_tooltip.player') }}:</span> {{ dataPlay.playerName }}
        </div>
        <div>
          <span class="bold">{{ $t('chalkboard_tooltip.minute') }}:</span> {{ dataPlay.minute }}
        </div>
        <div>
          <span class="bold">{{ $t('chalkboard_tooltip.opponent') }}:</span> {{ dataPlay.rivalName }}
          <img :src="dataPlay.rivalLogo" width="25" style="vertical-align:middle" />
        </div>
        <div
          v-if="/^[+]?([0-1]+(?:[\.][0-9]*)?|\.[0-9]+)$/.test(dataPlay.xGi) && dataPlay.xGi <= 1 && !dataPlay.isOwnGoal"
        >
          <span class="bold">{{ $t('chalkboard_tooltip.xGi') }}:</span> {{ Number(dataPlay.xGi) | ceilMod(4) }}
        </div>
        <div
          v-if="/^[+]?([0-1]+(?:[\.][0-9]*)?|\.[0-9]+)$/.test(dataPlay.xGf) && dataPlay.xGf <= 1 && !dataPlay.isOwnGoal"
        >
          <span class="bold">{{ $t('chalkboard_tooltip.xGf') }}:</span> {{ Number(dataPlay.xGf) | ceilMod(4) }}
        </div>
        <div class="line-buttom" v-if="isMobile">
          <div class="line-sep-buttom"></div>
          <div class="button-viewvideos" @click="setOpenMediaMovil(dataPlay, 2)">
            <div class="button-viewvideos__text">Ver video</div>
            <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_playfield.png" />
          </div>
        </div>
      </div>
    </Tooltip>
  </section>
</template>

<script>
import Tooltip from '@/components/Elements/Tooltip';
import { mapGetters, mapMutations, mapState } from 'vuex';

import _ from 'lodash';
let resizeObserver = null;

/**
 * @module SoccerChalkboard
 */
export default {
  name: 'SoccerChalkboard',
  props: {
    plays: {
      type: Array,
      require: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    players: {
      type: Array,
      required: true,
    },
    games: {
      type: Array,
      required: false,
    },
    team: {
      type: Number,
      default: 0,
    },
    playValuesIndex: {
      type: Object,
      required: true,
    },
    analysisType: {
      type: String,
      required: false,
    },
    // Possible values: 'team' or 'player'
    sectionType: {
      type: String,
      required: false,
    },
  },
  components: {
    Tooltip,
  },
  data() {
    return {
      clickaux: false,
      selectedPlays: [],
      negativeColor: 'red',
      perspective: true,
      data: {
        x: 0,
        y: 0,
        visible: false,
      },
      dataPlay: {
        playerName: '',
        minute: 0,
        rivalLogo: '',
        categoryName: '',
        category: '',
        xGi: 0,
        xGf: 0,
        isOwnGoal: false,
      },
      initialSelectedOptions: {
        team: {
          offensive: [0],
          defensive: [6],
        },
        player: {
          offensive: [],
          defensive: [0, 1, 2, 4],
        },
        goalkeeper: {
          offensive: [],
          defensive: [1],
        },
      },
      isVisualizationTextVisible: false,
    };
  },
  mounted() {
    document.addEventListener('click', this.onClickOutside);
    if (this.sectionType === 'team') {
      this.updatePlayer({});
    }
    let initialOptions = [];
    if (this.player.position_id !== 1) {
      initialOptions = [...this.initialSelectedOptions[this.sectionType][this.analysisType]];
    } else {
      initialOptions = [...this.initialSelectedOptions['goalkeeper'][this.analysisType]];
    }
    this.selectedPlays = initialOptions.length ? initialOptions : this.localCategories.map(c => c.id);

    this.setUpResizeObserver();
  },
  watch: {
    isModalOpen() {
      let view = !this.isModalOpen ? '3D' : '2D';
      this.perspective = !this.isModalOpen;
      this.$emit('changePerspective', view);
    },
    perspective(newValue) {
      let view = newValue ? '3D' : '2D';
      this.$emit('changePerspective', view);
    },
  },
  computed: {
    ...mapGetters('playersGeneral', ['player']),
    isModalOpen() {
      return this.$store.state.mediaModal.isModalOpen;
    },
    ...mapGetters('filterGeneral', {
      getGamesPlayedByTeam: 'getGamesPlayedByTeam',
      getResults: 'getResults',
      getSections: 'getSections',
      getPlayingAs: 'getPlayingAs',
      getSelectedGamesIds: 'getSelectedGamesIds',
      seasonSelected: 'getSeasonId',
    }),
    ...mapGetters('teamsGeneral', {
      teamId: 'teamId',
    }),
    ...mapGetters('playersGeneral', {
      playerId: 'playerId',
    }),
    ...mapState(['windowWidth']),
    ...mapState('filterGeneral', ['tournamentsForMediaPlayer']),
    /**
     * @author Cristhian Gómez
     * @description Campo computado que devuelve boleano si se encuentra en la ruta player
     */
    isPlayerView() {
      return this.$route.name === 'player';
    },

    chalkboardViewBox() {
      return this.windowWidth > 384 ? '0 0 490 684' : '0 0 490 784';
    },
    isMobile() {
      return this.$mq === 'mobile';
    },

    categoriesWithXg() {
      if (this.sectionType === 'team') {
        return [0, 1, 2];
      } else if (this.player.position_id === 1) {
        return [];
      } else {
        return [0, 3, 4];
      }
    },

    /**
     * @author Rigoberto Sanchez
     * @description Metodo para convertir el arreglo de jugadas en un json, para trabajarlo con las demas jugadas, por si cambia la estructura o posicion de los elementos
     */
    preparedPlays() {
      return this.plays.map(p => ({
        playId: p[this.playValuesIndex.playId],
        gameId: p[this.playValuesIndex.gameId],
        teamId: p[this.playValuesIndex.teamId],
        playerId: p[this.playValuesIndex.playerId],
        momentOfPlay: p[this.playValuesIndex.momentOfPlay],
        categoryId: p[this.playValuesIndex.categoryId],
        categoryType: p[this.playValuesIndex.categoryType],
        matchLapse: p[this.playValuesIndex.matchLapse],
        section: p[this.playValuesIndex.section],
        matchResult: p[this.playValuesIndex.matchResult],
        playingAs: p[this.playValuesIndex.playingAs],
        total: p[this.playValuesIndex.total],
        x1: p[this.playValuesIndex.coordinate1X] * 100,
        y1: p[this.playValuesIndex.coordinate1Y] * 100,
        x2: p[this.playValuesIndex.coordinate2X] * 100,
        y2: p[this.playValuesIndex.coordinate2Y] * 100,
        x3: p[this.playValuesIndex.coordinate3X] * 100,
        y3: p[this.playValuesIndex.coordinate3Y] * 100,
        xGi: p[this.playValuesIndex.xGi],
        xGf: p[this.playValuesIndex.xGf],
      }));
    },

    /**
     * @author Rigoberto Sanchez
     * @description Metodo para obtener todas las categorias, determinar de cuantos puntos le corresponden, asi como asignar los colres, puntos y categorias golstats
     */
    localCategories() {
      return this.categories.map((c, i) => ({
        id: i,
        name: c.name,
        singleName: c.singleName,
        negative: c.negative || false,
        color: c.color,
        points: c.points,
        numPoints: c.points.length,
        categories: c.categories,
        invert: c.invert || [],
      }));
    },
    /**
     * @author Cristhian Gómez
     * @description Variable computada que devuelve un booleano dependiendo si todas ñas categorias estan seleccionadas
     */
    isFullCategoriesSelected() {
      return this.selectedPlays.length == this.localCategories.length;
    },
    /**
     * @author Rigoberto Sanchez
     * @description Metodo para obtener las categorias correspondientes a 1 punto
     */
    categoriesPlays1() {
      return [
        ...new Set(
          this.localCategories
            .filter(c => c.numPoints === 1)
            .map(c => c.categories)
            .flat(),
        ),
      ];
    },

    /**
     * @author Rigoberto Sanchez
     * @description Metodo para obtener las categorias correspondientes a 2 puntos
     */
    categoriesPlays2() {
      return [
        ...new Set(
          this.localCategories
            .filter(c => c.numPoints === 2)
            .map(c => c.categories)
            .flat(),
        ),
      ];
    },

    /**
     * @author Rigoberto Sanchez
     * @description Metodo para obtener las categorias correspondientes a 3 puntos
     */
    categoriesPlays3() {
      return [
        ...new Set(
          this.localCategories
            .filter(c => c.numPoints === 3)
            .map(c => c.categories)
            .flat(),
        ),
      ];
    },

    /**
     * @author Rigoberto Sanchez
     * @description  Metodo para calcular las jugadas que son de 1 punto, se obtienen las jugadas de la propiedad "plays", y se crea un array con las jugadas correspondientes.
     */
    plays1() {
      let categories = this.categoriesPlays1;
      let selected = this.selectedPlays;
      let plays = this.preparedPlays
        .filter(p => this.findCategoryInPlay(categories, p))
        .reduce((accumulator, p) => {
          let category = this.localCategories.find(c => this.findCategoryInPlay(c.categories, p));
          let player = this.players.find(i => i.player_id === p.playerId);
          let game = this.games.find(g => (g ? g.gameId === p.gameId : undefined));
          if (category && player && game) {
            let result = {
              category: category.id,
              categoryName: category.name,
              categorySingleName: category.singleName,
              color: category.color,
              playId: p.playId,
              player: p.playerId,
              playerName: player ? player.name : '',
              jersey: player ? player.jersey : '',
              matchlapse: p.matchLapse,
              x1: category.invert.includes(p.categoryId)
                ? 100 - p[`x${category.points[0]}`]
                : p[`x${category.points[0]}`],
              y1: category.invert.includes(p.categoryId)
                ? 100 - p[`y${category.points[0]}`]
                : p[`y${category.points[0]}`],
              momentOfPlay: p.momentOfPlay,
              rivalLogo: this.getRivalLogo(game, p),
            };

            if (this.analysisType === 'offensive' && this.categoriesWithXg.includes(category.id)) {
              result.xGi = p.xGi;
              result.xGf = p.xGf;
            }

            accumulator.push(result);
          }
          return accumulator;
        }, []);
      return plays.filter(p => selected.includes(p.category));
    },

    /**
     * @author Rigoberto Sanchez
     * @description  Metodo para calcular las jugadas que son de 2 puntos, se obtienen las jugadas de la propiedad "plays", y se crea un array con las jugadas correspondientes.
     */
    plays2() {
      let categories = this.categoriesPlays2;
      let selected = this.selectedPlays;
      let plays = this.preparedPlays
        .filter(p => this.findCategoryInPlay(categories, p))
        .reduce((accumulator, p) => {
          let category = this.localCategories.find(c => this.findCategoryInPlay(c.categories, p));
          let player = this.players.find(i => i.player_id === p.playerId);
          let game = this.games.find(g => (g ? g.gameId === p.gameId : undefined));
          if (category && player && game) {
            let result = {
              category: category.id,
              categoryName: category.name,
              categorySingleName: category.singleName,
              arrowColor: category.negative ? this.negativeColor : category.color,
              arrowMarkerColor: category.negative ? `url(#arrow-negative)` : `url(#arrow-${category.id})`,
              markerColor: category.color,
              playId: p.playId,
              player: p.playerId,
              playerName: player ? player.name : '',
              jersey: player ? player.jersey : '',
              matchlapse: p.matchLapse,
              x1: category.invert.includes(p.categoryId)
                ? 100 - p[`x${category.points[0]}`]
                : p[`x${category.points[0]}`],
              y1: category.invert.includes(p.categoryId)
                ? 100 - p[`y${category.points[0]}`]
                : p[`y${category.points[0]}`],
              x2: category.invert.includes(p.categoryId)
                ? 100 - p[`x${category.points[1]}`]
                : p[`x${category.points[1]}`],
              y2: category.invert.includes(p.categoryId)
                ? 100 - p[`y${category.points[1]}`]
                : p[`y${category.points[1]}`],
              momentOfPlay: p.momentOfPlay,
              rivalLogo: this.getRivalLogo(game, p),
            };

            if (this.analysisType === 'offensive' && this.categoriesWithXg.includes(category.id)) {
              result.xGi = p.xGi;
              result.xGf = p.xGf;
            }

            accumulator.push(result);
          }
          return accumulator;
        }, []);
      return plays.filter(p => selected.includes(p.category));
    },

    /**
     * @author Rigoberto Sanchez
     * @description Metodo para calcular las jugadas que son de 3 puntos, se obtienen las jugadas de la propiedad "plays", y se crea un array con las jugadas correspondientes.
     */
    plays3() {
      let categories = this.categoriesPlays3;
      let selected = this.selectedPlays;
      let plays = this.preparedPlays
        .filter(p => {
          let result = this.findCategoryInPlay(categories, p);
          return result;
        })
        .reduce((accumulator, p) => {
          let category = this.localCategories.find(c => this.findCategoryInPlay(c.categories, p));
          let player = this.players.find(i => i.player_id === p.playerId);
          let game = this.games.find(g => (g ? g.gameId === p.gameId : undefined));
          if (category && player && game) {
            let result = {
              category: category.id,
              categoryName: category.name,
              categorySingleName: category.singleName,
              arrowColor: category.negative ? this.negativeColor : category.color,
              arrowMarkerColor: category.negative ? `url(#arrow-negative)` : `url(#arrow-${category.id})`,
              markerColor: category.color,
              playId: p.playId,
              player: p.playerId,
              playerName: player ? player.name : '',
              jersey: player ? player.jersey : '',
              matchlapse: p.matchLapse,
              x1: category.invert.includes(p.categoryId)
                ? 100 - p[`x${category.points[0]}`]
                : p[`x${category.points[0]}`],
              y1: category.invert.includes(p.categoryId)
                ? 100 - p[`y${category.points[0]}`]
                : p[`y${category.points[0]}`],
              x2: category.invert.includes(p.categoryId)
                ? 100 - p[`x${category.points[1]}`]
                : p[`x${category.points[1]}`],
              y2: category.invert.includes(p.categoryId)
                ? 100 - p[`y${category.points[1]}`]
                : p[`y${category.points[1]}`],
              x3: category.invert.includes(p.categoryId)
                ? 100 - p[`x${category.points[2]}`]
                : p[`x${category.points[2]}`],
              y3: category.invert.includes(p.categoryId)
                ? 100 - p[`y${category.points[2]}`]
                : p[`y${category.points[2]}`],
              momentOfPlay: p.momentOfPlay,
              rivalLogo: this.getRivalLogo(game, p),
            };
            if (category.id === 0 && this.analysisType === 'offensive' && p.teamId) {
              result.isOwnGoal = this.team !== p.teamId;
            } else if (category.id === 0 && this.analysisType === 'defensive' && p.teamId) {
              result.isOwnGoal = this.team === p.teamId;
            } else {
              result.isOwnGoal = false;
            }

            if (this.analysisType === 'offensive' && this.categoriesWithXg.includes(category.id)) {
              result.xGi = p.xGi;
              result.xGf = p.xGf;
            }

            accumulator.push(result);
          }
          return accumulator;
        }, []);
      return plays.filter(p => selected.includes(p.category));
    },

    /**
     * @author Fernando Mellone
     * @description propiedad que determina si el xGf acumulado es visible.
     */
    istotalXgfVisible() {
      return this.selectedPlays.some(play => this.categoriesWithXg.includes(play)) && this.analysisType === 'offensive';
    },

    /**
     * @author Fernando Mellone
     * @description propiedad que calcula el xGf total a mostrarse en pantalla.
     */
    totalXgf() {
      const playsByMoment1 = _.groupBy(this.plays1, 'momentOfPlay');
      const playsByMoment2 = _.groupBy(this.plays2, 'momentOfPlay');
      const playsByMoment3 = _.groupBy(this.plays3, 'momentOfPlay');

      const allPlays = { ...playsByMoment1, ...playsByMoment2, ...playsByMoment3 };

      let acc = 0;

      Object.entries(allPlays).forEach(play => {
        if (this.categoriesWithXg.includes(play[1][0].category) && !play.isOwnGoal) acc += Number(play[1][0].xGf);
      });

      return acc;
    },

    totalPlays() {
      const playsByMoment1 = _.groupBy(this.plays1, 'momentOfPlay');
      const playsByMoment2 = _.groupBy(this.plays2, 'momentOfPlay');
      const playsByMoment3 = _.groupBy(this.plays3, 'momentOfPlay');

      let plays1Qty = Object.keys(playsByMoment1).length;
      let plays2Qty = Object.keys(playsByMoment2).length;
      let plays3Qty = Object.keys(playsByMoment3).length;

      const total = plays1Qty + plays2Qty + plays3Qty;

      return total;
    },
  },
  methods: {
    ...mapMutations('playersGeneral', ['updatePlayer']),
    ...mapMutations('mediaModal', ['setModalInitialState', 'setIsModalOpen']),
    hideAll() {
      this.data.visible = false;
    },
    onClickOutside(event) {
      const { collabsibles } = this.$refs;
      if (!collabsibles || collabsibles.contains(event.target)) return;
      if (this.isMobile) {
        if (!this.clickaux) {
          this.hideAll();
        }
      }
      this.clickaux = false;
    },
    setOpenMedia(category, type, index = null) {
      const categorySingleName = index !== null ? this.categories[index].singleName : category.categorySingleName;
      const categoryName = index !== null ? this.categories[index].name : category.categoryName;
      let jsonConfig = {};
      if (type === 2) {
        if (!this.isMobile) {
          const categoriesSelected = this.categories[category.category].categories;
          const isRivalSubject =
            this.sectionType === 'team' && this.analysisType === 'defensive' && categoryName.includes('recibidos');
          jsonConfig = {
            seasonId: this.seasonSelected,
            tournaments: this.tournamentsForMediaPlayer,
            categoryIds: categoriesSelected,
            categorySingleName,
            mainSectionType: 1,
            playListType: this.sectionType === 'team' ? 3 : 2,
            matchResult: this.getResults,
            playData: category,
            gameIds: this.getSelectedGamesIds,
            isRivalSubject,
            avoidCategorySingleName: isRivalSubject,
            advancedFilter: {
              playListTitle: categoryName,
              mainCategoryId: {},
              playingAs: this.getPlayingAs ? [this.getPlayingAs] : [1, 2],
              timeSections: this.getSections,
              fieldSections: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
            },
          };
        }
      }
      if (type === 1) {
        const isRivalSubject = this.sectionType === 'team' && categoryName.includes('recibidos');
        jsonConfig = {
          seasonId: this.seasonSelected,
          tournaments: this.tournamentsForMediaPlayer,
          categoryIds: category,
          categorySingleName,
          mainSectionType: 1,
          playListType: this.sectionType === 'team' ? 3 : 2,
          gameIds: this.getSelectedGamesIds,
          matchResult: this.getResults,
          playData: {},
          isRivalSubject,
          avoidCategorySingleName: isRivalSubject,
          advancedFilter: {
            playListTitle: categoryName,
            mainCategoryId: {},
            playingAs: this.getPlayingAs ? [this.getPlayingAs] : [1, 2],
            timeSections: this.getSections,
            fieldSections: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
          },
        };
      }
      if (type === 1) {
        if (this.teamId) {
          jsonConfig.playerIds = [];
          jsonConfig.teamId = this.teamId;
        } else {
          jsonConfig.playerIds = [this.playerId];
          jsonConfig.teamId = 0;
        }
      } else {
        if (!this.isMobile) {
          if (this.teamId) {
            jsonConfig.playerIds = [];
            jsonConfig.teamId = this.teamId;
          } else {
            jsonConfig.playerIds = [this.playerId];
            jsonConfig.teamId = 0;
          }
        }
      }
      if (type === 1) {
        this.setModalInitialState(jsonConfig);
        this.setIsModalOpen(true);
      } else {
        if (!this.isMobile) {
          this.setModalInitialState(jsonConfig);
          this.setIsModalOpen(true);
        }
      }
    },
    setOpenMediaMovil(category, type) {
      this.data.visible = false;
      let jsonConfig = {};
      if (type === 2) {
        if (this.isMobile) {
          const categoriesSelected = this.categories[category.category].categories;
          jsonConfig = {
            seasonId: this.seasonSelected,
            tournaments: this.tournamentsForMediaPlayer,
            categoryIds: categoriesSelected,
            categorySingleName: category.categorySingleName,
            mainSectionType: 1,
            playListType: this.sectionType === 'team' ? 3 : 2,
            gameIds: this.getSelectedGamesIds,
            matchResult: this.getResults,
            playData: category,
            teamId: this.teamId,
            advancedFilter: {
              playListTitle: category.categoryName,
              mainCategoryId: {},
              playingAs: this.getPlayingAs ? [this.getPlayingAs] : [1, 2],
              timeSections: this.getSections,
              fieldSections: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
            },
          };
        }
      }

      if (type === 2) {
        if (this.isMobile) {
          if (this.teamId) {
            jsonConfig.playerIds = [];
            jsonConfig.teamId = this.teamId;
          } else {
            jsonConfig.playerIds = [this.playerId];
            jsonConfig.teamId = 0;
          }
        }
      }
      if (type === 2) {
        if (this.isMobile) {
          this.setModalInitialState(jsonConfig);
          this.setIsModalOpen(true);
        }
      }
    },

    /**
     * @author Alejandro
     * @description There are some categories in format categoryId and r, e.g. 35_r, these categories
     * with _r are rival plays. So these method look for those plays an compare it's team id.
     * @param {Array} categories
     * @param {Object} play
     */
    findCategoryInPlay(categories, play) {
      return categories.find(category => {
        let categoryAux = 0;
        if (typeof category === 'string') {
          if (play.teamId) {
            categoryAux = Number(category.split('_').shift());
            return categoryAux === play.categoryId && play.teamId !== this.team;
          }
        } else {
          // Team plays has a teamId, player plays not.
          return play.teamId ? category === play.categoryId && this.team === play.teamId : category === play.categoryId;
        }
        return false;
      });
    },
    getRivalLogo(game, play) {
      if (this.sectionType === 'team') {
        return game.homeTeamId === this.team ? game.visitingTeamLogo : game.homeTeamLogo;
      }
      return play.playingAs === 1 ? game.visitingTeamLogo : game.homeTeamLogo;
    },
    setUpResizeObserver() {
      if (window.ResizeObserver) {
        resizeObserver = new ResizeObserver(() => {
          this.isVisualizationTextVisible =
            this.$refs.soccerChalkboard && this.$refs.soccerChalkboard.clientWidth > 524;
        });

        resizeObserver.observe(this.$refs.soccerChalkboard);
      } else {
        throw new Error('Resize observer not supported!');
      }
    },
    /**
     * @author Rigoberto Sanchez, Cristhian Gómez
     * @description Metodo para cuando el usuario desea seleccionar todos los elementos, se agregan al elemento "selectedPlays",
     * en caso de que esten todas las categorías seleccionados el método limpiará todas las categorías.
     */
    onClickSelectAll() {
      if (!this.isFullCategoriesSelected) {
        this.selectedPlays = this.localCategories.map(i => i.id);
      } else {
        this.selectedPlays = [];
      }
      this.$emit('changeSelectAll', this.isFullCategoriesSelected);
    },

    /**
     * @author Rigoberto Sanchez
     * @description Metodo para obtener los datos correspondientes a la jugada y mostrarlos en el tooltip
     */
    onClickOver(event, play) {
      this.clickaux = true;
      if (this.isMobile) {
        this.dataPlay.category = play.category;
        this.dataPlay.playerName = play.playerName || '';
        this.dataPlay.minute = parseInt(play.momentOfPlay.split(':')[0]) || '';
        this.dataPlay.rivalLogo = play.rivalLogo || '';
        this.dataPlay.categoryName = play.categoryName || '';
        this.dataPlay.xGi = String(play.xGi);
        this.dataPlay.xGf = String(play.xGf);
        this.dataPlay.isOwnGoal = play.isOwnGoal;
        this.data.x =
          event.pageX + 340 > this.$refs.soccerChalkboard.clientWidth
            ? this.$refs.soccerChalkboard.clientWidth - 340 < 0
              ? 55
              : this.$refs.soccerChalkboard.clientWidth - 340
            : event.pageX;
        this.data.y = event.pageY - 50;
        this.data.visible = true;
      }
    },
    onMouseOver(event, play) {
      if (!this.isMobile) {
        this.dataPlay.category = play.category;
        this.dataPlay.playerName = play.playerName || '';
        this.dataPlay.minute = parseInt(play.momentOfPlay.split(':')[0]) || '';
        this.dataPlay.rivalLogo = play.rivalLogo || '';
        this.dataPlay.categoryName = play.categoryName || '';
        this.dataPlay.xGi = String(play.xGi);
        this.dataPlay.xGf = String(play.xGf);
        this.dataPlay.isOwnGoal = play.isOwnGoal;
        this.data.x =
          event.pageX + 340 > this.$refs.soccerChalkboard.clientWidth
            ? this.$refs.soccerChalkboard.clientWidth - 340 < 0
              ? 55
              : this.$refs.soccerChalkboard.clientWidth - 340
            : event.pageX;
        this.data.y = event.pageY - 75;
        this.data.visible = true;
      }
    },

    /**
     * @author Rigoberto Sanchez
     * @description Metodo para indicar que el usuario ha salido del elemento y dejar de mostrar el tooltip
     */
    onMouseLeave() {
      if (!this.isMobile) {
        this.data.visible = false;
      }
    },

    /**
     * @author Rigoberto Sanchez
     * @descripcion Emit event when change category
     */
    onClickCategory(value) {
      this.$emit('changeCategory', {
        name: value.target.name,
        checked: value.target.checked,
      });
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onClickOutside);
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.line-sep-buttom {
  width: 100%;
  height: 1px;
  margin-top: 5px;
  margin-bottom: 10px;
  background-color: rgba(255, 255, 255, 0.48);
}
.line-buttom {
  width: 100%;
  height: 45px;
  display: inline-block;
  justify-content: center;
  align-items: center;
}

.button-viewvideos {
  width: 123px;
  height: 30px;
  border-radius: 25px;
  background-color: #a5cd39;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  &__text {
    font-family: 'Avenir-Bold';
    font-size: 13px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: #fff;
  }
  img {
    filter: grayscale(100%);
    height: 20px;
    margin-left: 3px;
  }
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
}
.categoryline {
  width: 100%;
  height: auto;
  display: inline-flex;
  justify-content: left;
  align-items: center;
  &__cate {
    width: 95%;
  }
  img {
    height: 20px;
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }
}
.title-field {
  width: 351px;
  height: 26px;
  border-radius: 11px;
  background-color: rgba(35, 35, 35, 0.7);
  text-align: center;
  line-height: 26px;
  font-size: 14px;
  font-weight: normal;
  margin: 0 auto;
  font-family: 'Heebo';
  margin-bottom: 15px;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}
.soccer-chalkboard {
  //margin-bottom: 1.5rem;
  &__header {
    &__switch {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    & .has-vertical-divider.title {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}
.field {
  display: inline-flex;
  align-items: center;
  .switch.is-rounded {
    margin: 0px;
  }
  .control-label {
    &.left {
      padding: 0px;
    }
    &.right {
      padding-right: 5px;
    }
  }
  &.has-horizontal-divider {
    width: 100%;
  }
}
.field-title {
  position: absolute;
  left: 12px;
}
svg {
  width: 70%;
  margin: 0 auto;
  display: inline-block;
}
.perspective3d {
  transform: perspective(700px) rotateX(25deg) translate3d(0, -50px, 0);
  transform-style: preserve-3d;
  animation: changePerspective3d 0.1s;
}
.perspective2d {
  animation: changePerspective2d 0.1s;
}

@keyframes changePerspective3d {
  0% {
    transform: perspective(700px) rotateX(0) translate3d(0, 0, 0);
  }
  20% {
    transform: perspective(700px) rotateX(5deg) translate3d(0, -10px, 0);
  }
  40% {
    transform: perspective(700px) rotateX(10deg) translate3d(0, -20px, 0);
  }
  60% {
    transform: perspective(700px) rotateX(15deg) translate3d(0, -30px, 0);
  }
  80% {
    transform: perspective(700px) rotateX(20deg) translate3d(0, -40px, 0);
  }
  100% {
    transform: perspective(700px) rotateX(25deg) translate3d(0, -50px, 0);
  }
}

@keyframes changePerspective2d {
  0% {
    transform: perspective(700px) rotateX(25deg) translate3d(0, -50px, 0);
  }
  20% {
    transform: perspective(700px) rotateX(20deg) translate3d(0, -40px, 0);
  }
  40% {
    transform: perspective(700px) rotateX(15deg) translate3d(0, -30px, 0);
  }
  60% {
    transform: perspective(700px) rotateX(10deg) translate3d(0, -20px, 0);
  }
  80% {
    transform: perspective(700px) rotateX(5deg) translate3d(0, -10px, 0);
  }
  100% {
    transform: perspective(700px) rotateX(0) translate3d(0, 0, 0);
  }
}
.has-gray-background {
  background: #f1f2f2;
}
.title {
  font-family: 'Avenir-Demi';
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #5b5b5b;
}
.has-vertical-divider {
  border-left: 1px solid #bebcbc;
  margin: 1rem 0;
}
.has-horizontal-divider {
  border-bottom: 1px solid #d7d7d7;
}
.has-gray-background {
  background: #f1f2f2;
}
.is-pointer {
  cursor: pointer !important;
}
.tooltip-data {
  font-family: 'Avenir-Medium';
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  color: #ffffff;
}
.tooltip-data .bold {
  font-family: 'Avenir-Bold';
}
</style>
